export class Schema {
    static rebuild(builder, requires = [], omits = []) {
        const schema = builder();
        requires.forEach((key) => {
            schema[key].required();
        });
        omits.forEach((key) => {
            delete schema[key];
        });
        return schema;
    }
    static required(schema, required) {
        if (!required) {
            return schema;
        }
        Object.keys(schema).forEach((key) => {
            schema[key].required();
        });
        return schema;
    }
    static exclude(schema, excludes) {
        const copy = { ...schema };
        excludes.forEach((key) => {
            delete copy[key];
        });
        return copy;
    }
    static pick(schema, picks) {
        const copy = {};
        picks.forEach((key) => {
            copy[key] = schema[key];
        });
        return copy;
    }
}
//# sourceMappingURL=schema.js.map